module.exports = __webpack_public_path__ + "static/media/file-icon.2d40e85d.svg";